import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productPipe',
  pure: false
})
export class ProductPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return Object.keys(value).map(ind => {
        return value[ind];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/product-pipe.pipe.ts